import axios from "axios";
import { DEFAULT_MONGO_CONNECTION_NAME, SERVER_URL } from "./constants";
import useUserStore from "./Stores/userStore";
import { errorNotfiy } from "@/components/Global/Toast";

// Setup Axios instance
const api = axios.create({
  baseURL: SERVER_URL,
});

// Add a request interceptor to inject the access token into headers
api.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem("accessToken");

    config.headers["tenant-id"] = useUserStore.getState()?.tenantId;

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    let additionalParam = {
      selectedWorkSpace:
        useUserStore.getState()?.selectedWorkSpace || undefined,
      userId: useUserStore.getState()?.user?._id || undefined,
    };

    if (config.method === "get" || config.method === "delete") {
      // For requests that do not have a body (GET, DELETE)
      config.params = {
        ...config.params,
        ...additionalParam,
        currentTime: new Date().getTime(),
      };
    } else {
      // For requests that have a body (POST, PUT, PATCH)
      if (config.data && typeof config.data === "object") {
        config.params = { ...additionalParam };
      } else {
        config.params = additionalParam;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 (Unauthorized) and refresh the token
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken"); // Get refresh token

      if (refreshToken) {
        // Try to refresh the access token
        try {
          const response = await api.post("/auth/refresh-tokens", {
            refreshToken,
          });

          const { accessToken } = response.data;

          // Store new access token

          localStorage.setItem("accessToken", accessToken?.token);

          // Retry the original request with new access token
          api.defaults.headers.common["Authorization"] =
            `Bearer ${accessToken.token}`;
          return api(originalRequest);
        } catch (refreshError) {
          console.error("Unable to refresh token", refreshError);
          // Optional: Redirect to login page if refresh fails
          // window.location.href = '/login';
        }
      }
    }
    if (error.response.status === 403 && error?.response?.data?.message == "User is blocked. Contact with Adminstrator") {
      errorNotfiy("User is blocked. Contact with Adminstrator")
      useUserStore.getState()?.logout()


    }

    return Promise.reject(error.response || error);
  }
);

// export const getToken = () => {
//   const user = localStorage.getItem("user");
//   if (user) {
//     return JSON.parse(user).token;
//   }
// };

export const serverGET = async (path) => {
  try {
    let response = await api.get(path);

    if (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.statusText;
      }
    } else {
      return undefined;
    }
  } catch (error) {
    if (error?.status === 403) {
      errorNotfiy("Forbidden: You do not have access to this resource.");
    } else {
      errorNotfiy(error?.statusText || "An unexpected error occurred.");
    }

    return undefined;
  }
};

export const serverPOST = async (path, body) => {
  try {
    let response = await api.post(path, body, {
      // headers: { token: getToken() },/
    });

    if (response) {
      if (response.status === 201 || response.status === 204) {
        return response.data;
      } else {
        return response.statusText;
      }
    } else {
      return undefined;
    }
  } catch (error) {
    if (error?.status === 403) {
      // errorNotfiy("Forbidden: You do not have access to this resource.")
      throw new Error("Forbidden: You do not have access to this resource.");
    } else {
      throw new Error(
        error?.data?.message
          ? error.data?.message
          : error?.data
            ? error?.data
            : error?.statusText || "An unexpected error occurred."
      );
    }
  }
};

export const serverPUT = async (path, body) => {
  try {
    let response = await api.put(path, body, {
      // headers: { token: getToken() },
    });
    if (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.statusText;
      }
    } else {
      return undefined;
    }
  } catch (error) {
    if (error?.status === 403) {
      throw new Error("Forbidden: You do not have access to this resource.");
    } else {
      console.log(error);
      throw new Error(
        error?.data?.message
          ? error.data?.message
          : error?.statusText || "An unexpected error occurred."
      );
    }
  }
};

export const serverDELETE = async (path) => {
  try {
    let response = await api.delete(path, {
      // headers: { token: getToken() },
    });
    if (response) {
      if (response.data.code === 200) {
        return response.data.data;
      } else if (response.data.code === 401) {
        localStorage.removeItem("user");
        window.location.reload();
      } else {
        return response.data.message;
      }
    } else {
      return undefined;
    }
  } catch (error) {
    if (error?.status === 403) {
      throw new Error("Forbidden: You do not have access to this resource.");
    } else {
      throw new Error(error?.statusText || "An unexpected error occurred.");
    }
  }
};

export const serverPATCH = async (path, body) => {
  try {
    let response = await api.patch(path, body, {
      // headers: { token: getToken() },
    });
    if (response) {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.statusText;
      }
    } else {
      return undefined;
    }
  } catch (error) {
    if (error?.status === 403) {
      throw new Error("Forbidden: You do not have access to this resource.");
    } else {
      throw new Error(error?.statusText || "An unexpected error occurred.");
    }
  }
};

export default api;

// function getToken(): any | import("axios").AxiosHeaderValue {
//   throw new Error("Function not implemented.");
// }
